export default "__VITE_ASSET__D2JFc4mj__"